module.exports = __webpack_public_path__ + "img/TasksCreated1.135e3b1b.png";